import React, { memo } from 'react';

import { Tooltip } from 'antd';
import { BsSend } from 'react-icons/bs';
import TMIcon from 'tm-icons-library';
import { IconName } from 'tm-icons-library/dist/IconTypes';

import { useTheme } from '../../../../context/ThemeProvider';
import { ACTION_TOOLTIP_DELAY_MEDIUM } from '../../../../shared/data';
import {
  ITQShoutout,
  UserProfileTabItemTypeValue,
} from '../../../../types/tqConnectTypes/user';

const ICON_SIZE = 20;

const TOOLTIP_DELAY = ACTION_TOOLTIP_DELAY_MEDIUM;

interface Props {
  type: UserProfileTabItemTypeValue;
  shoutout: ITQShoutout;
  canPostToCommunity: boolean;
}

const ShoutoutCardBottomActions: React.FC<Props> = ({
  // type,
  // shoutout,
  canPostToCommunity,
}) => {
  const { colors: COLORS } = useTheme();

  // const dispatch = useAppDispatch();

  // const { from, to, category, coverImage, description } = shoutout;

  // const linkToShare = useMemo(() => window.location.href, []);

  const renderStatItem = (data: {
    icon: IconName | React.ReactNode;
    size: number;
    text: number | string;
    onPress?: () => void;
    onPressIcon?: () => void;
    onPressText?: () => void;
    style?: React.CSSProperties;
    iconStyle?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    tooltip?: React.ReactNode;
    tooltipOnIcon?: React.ReactNode;
    tooltipOnText?: React.ReactNode;
  }) => {
    const {
      icon,
      size = ICON_SIZE,
      text,
      onPress,
      onPressIcon,
      onPressText,
      style,
      iconStyle,
      textStyle,
      tooltip,
      tooltipOnIcon,
      tooltipOnText,
    } = data;

    return (
      <Tooltip title={tooltip} mouseEnterDelay={TOOLTIP_DELAY}>
        <div
          className="action-item"
          onClick={onPress}
          style={{ cursor: onPress ? 'pointer' : 'auto', ...style }}>
          <Tooltip title={tooltipOnIcon} mouseEnterDelay={TOOLTIP_DELAY}>
            <span
              className="item__icon"
              onClick={onPressIcon}
              style={{ cursor: onPressIcon ? 'pointer' : 'inherit' }}>
              {typeof icon === 'string' ? (
                <TMIcon
                  name={icon as IconName}
                  size={size}
                  color={COLORS.ICON}
                  style={iconStyle}
                />
              ) : (
                icon
              )}
            </span>
          </Tooltip>

          {text && text !== '0' ? (
            <Tooltip title={tooltipOnText} mouseEnterDelay={TOOLTIP_DELAY}>
              <span
                className="item__text"
                onClick={onPressText}
                style={{
                  cursor: onPressText ? 'pointer' : 'inherit',
                  ...textStyle,
                }}>
                {text}
              </span>
            </Tooltip>
          ) : null}
        </div>
      </Tooltip>
    );
  };

  return (
    <div className="card__bottom__actions">
      {/* <Popover
        content={<PostShareOptions postLinkToShare={linkToShare} />}
        overlayStyle={{ zIndex: 998 }}>
        {renderStatItem({
          icon: 'arrow-redo-outline',
          size: ICON_SIZE,
          text: 'Share',
          style: {
            cursor: 'pointer',
            marginLeft: 'auto',
          },
        })}
      </Popover> */}

      {canPostToCommunity &&
        renderStatItem({
          icon: <BsSend size={18} color={COLORS.ICON} />,
          size: 18,
          text: 'Post',
          tooltip: 'Post and share in community',
          onPress: () => {},
          // dispatch(
          //   setPostModalState({
          //     isOpen: true,
          //     type: 'channels',
          //     post: {
          //       caption:
          //         type === 'received'
          //           ? `🎉 Received an amazing shoutout from ${from?.name}! 🙌🏻✨ So grateful for the recognition and support!`
          //           : `Giving a well-deserved shoutout to ${to?.name}! 👏🏻 Amazing work - keep shining!`,
          //       tqConnectShoutout: shoutout._id,
          //     },
          //     tqConnectShoutout: {
          //       _id: shoutout._id,
          //       from,
          //       to,
          //       category,
          //       coverImage,
          //       description,
          //       visibility: 'channel-only',
          //     },
          //   }),
          // ),
        })}
    </div>
  );
};

export default memo(ShoutoutCardBottomActions);
